import { PrimaryDrawer } from "../../../../Shared/components/Drawer/PrimaryDrawer";
import { Box, Button, Typography, FormControl, RadioGroup, FormControlLabel, Radio, TextField } from "@mui/material";
import { Space, Row, Col } from "antd";
import { SelectedIcon, UnSelectedIcon } from "../../../../Shared/components/Icons/selectedIcon";
import { AutoCompleteComponent } from "../../../../Shared/components/AutoCompleteComponent";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import DateIcon from "../../../../Shared/components/Icons/Date";


export const QueryForm = (props) => {
    const { form, handleSubmit, changeHandler, visible, customObject,
        handleClose, clsx, classes, error, customerGroupdetails, customerDetails } = props;
    return (
        <PrimaryDrawer
            anchor={'right'}
            open={visible}
            variant={'temporary'}
            handleClose={() => handleClose()}
            title={'Run Load Query'}
            width={"495px"}
            className={clsx(classes.closeBackGround, classes.width100P)}
            component={
                <Box
                    className={clsx(classes.customForm, classes.removeUnderline)}
                    component="form"
                    autoComplete="off"
                    onSubmit={(e) => handleSubmit(e)}>
                    <div className={classes.customFormFlex}>
                        <Row>
                            <Col span={24}>
                                <Row>
                                    <Col span={12}>
                                        <Typography variant={'h6'} className={clsx(classes.customLink, classes.typographyHeader, classes.bold)}>Filter By</Typography>
                                        <FormControl
                                            className={clsx(classes.margin10t, classes.dropDownPointer, classes.customRadioButton, classes.customQueryRadioButton)}
                                            variant={'standard'}
                                            fullWidth>
                                            <RadioGroup
                                                defaultValue={"ALL"}
                                                aria-labelledby="demo-customized-radios"
                                                name="customerSpec"
                                                value={form.customerSpec}
                                                onChange={(e) => changeHandler(e)}>
                                                <FormControlLabel value={'ALL'} control={<Radio
                                                    checkedIcon={<UnSelectedIcon />}
                                                    icon={<SelectedIcon />}
                                                />} label="All Customers" />
                                                <FormControlLabel value={'GROUP'} control={<Radio
                                                    checkedIcon={<UnSelectedIcon />}
                                                    icon={<SelectedIcon />}
                                                />} label="Customer Group" />
                                                <FormControlLabel value={'SPECIFIC'} control={<Radio
                                                    checkedIcon={<UnSelectedIcon />}
                                                    icon={<SelectedIcon />}
                                                />} label="Customer" />
                                            </RadioGroup>
                                        </FormControl>
                                    </Col>
                                    <Col span={12}>
                                        <AutoCompleteComponent
                                            name={["Date"]}
                                            disabled={true}
                                            heads={[{ 'key': 'label', 'name': 'Name' }]}
                                            details={[{ id: 'invoiceDate', label: 'Invoice Date' }, { id: 'deliveryDate', label: 'Delivery Date' }]}
                                            parentValue={customObject([{ id: 'invoiceDate', label: 'Invoice Date' }, { id: 'deliveryDate', label: 'Delivery Date' }], 'invoiceDate')}
                                            onChange={(data) => changeHandler(data.id, 'dateType')}
                                            position={"bottom"}
                                            customClasses={classes.margin10t}
                                        />
                                    </Col>
                                </Row>
                            </Col>
                            <Col span={24}>
                                {
                                    form?.customerSpec === 'GROUP' &&
                                    <AutoCompleteComponent
                                        name={["Select Customer Group"]}
                                        heads={[{ 'key': 'name', 'name': 'Name' }]}
                                        details={customerGroupdetails}
                                        parentValue={customObject(customerGroupdetails, form?.customerGroupId)}
                                        onChange={(data) => changeHandler(data.id, 'customerGroupId')}
                                        position={"bottom"}
                                        customClasses={clsx(classes.margin20t)}
                                        parentError={error.customerGroupId}
                                    />
                                }
                                {
                                    form?.customerSpec === 'SPECIFIC' &&
                                    <AutoCompleteComponent
                                        name={["Select Customer"]}
                                        heads={[{ 'key': 'name', 'name': 'Name' }]}
                                        details={customerDetails}
                                        parentValue={customObject(customerDetails, form?.customerId)}
                                        onChange={(data) => changeHandler(data.id, 'customerId')}
                                        position={"bottom"}
                                        customClasses={clsx(classes.margin20t)}
                                        parentError={error.customerId}
                                    />
                                }
                            </Col>
                            <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                <div className={clsx(classes.margin30t, classes.dateAdjust)}>
                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <DesktopDatePicker
                                            fullWidth
                                            slots={{
                                                openPickerIcon: DateIcon
                                            }}
                                            views={['year', 'month', 'day']}
                                            value={form?.fromDate || null}
                                            format='dd/MM/yyyy'
                                            label="From Date"
                                            InputProps={{
                                                classes: {
                                                    input: classes.textFieldColor,
                                                }
                                            }}
                                            slotProps={{ textField: { variant: 'outlined' } }}
                                            onChange={(newValue) => {
                                                (newValue === null || newValue === 'Invalid Date') ?
                                                    changeHandler(new Date(), 'fromDate') :
                                                    changeHandler(newValue, 'fromDate')
                                            }}
                                        />
                                    </LocalizationProvider>
                                </div>
                            </Col>
                            <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                <div className={clsx(classes.margin30t, classes.dateAdjust)}>
                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <DesktopDatePicker
                                            fullWidth
                                            slots={{
                                                openPickerIcon: DateIcon
                                            }}
                                            views={['year', 'month', 'day']}
                                            value={form?.toDate || null}
                                            format='dd/MM/yyyy'
                                            label="To Date"
                                            InputProps={{
                                                classes: {
                                                    input: classes.textFieldColor,
                                                }
                                            }}
                                            slotProps={{ textField: { variant: 'outlined' } }}
                                            onChange={(newValue) => {
                                                (newValue === null || newValue === 'Invalid Date') ?
                                                    changeHandler(new Date(), 'toDate') :
                                                    changeHandler(newValue, 'toDate')
                                            }}
                                            renderInput={(params) => <TextField autoComplete='one-time-code' {...params} />}
                                        />
                                    </LocalizationProvider>
                                </div>
                            </Col>
                        </Row>
                    </div>
                    <div className={clsx(classes.btnParent)}>
                        <Space direction="horizontal" align="center" size={[10, 10]}>
                            <Button
                                key="save"
                                color="primary"
                                variant="contained"
                                type={'submit'}
                                className={clsx(classes.modalBtn)}>OK
                            </Button>
                            <Button
                                key="Cancel"
                                color="primary"
                                variant="contained"
                                onClick={() => handleClose()}
                                className={clsx(classes.AddMoreBtn)}
                            >Cancel</Button>
                        </Space>
                    </div>
                </Box>
            }
        />
    )
}